import styles from "./index.module.css";

const ComingSoon = () => {
  return (
    <div className={styles["bgimg"]}>
      <div className={styles["middle"]}>
        <h1>COMING SOON</h1>
      </div>
    </div>
  );
};

export default ComingSoon;
